<template>



    <div id="formLogin" class="container w-100 py-5">



        <div class="row justify-content-center-container"> <!-- container -->

            <div class="col-12 col-lg-4"> <!-- immagine -->

                <div class="h-100 w-100 bg-dark"
                    style="background-image: url('https://clienti.exactnetwork.net/pretail/images/login-bkg-sm.jpg'); background-position: center; background-repeat: no-repeat;">
                    <div class="h-100 d-flex justify-content-center align-items-center text-center text-white"
                        style="text-shadow: 2px 2px 5px black;">
                        <p class="h2 px-4 py-5"> eXact Accesso Clienti</p>
                    </div>
                </div>


            </div>


            <div class="col-12 col-lg-4"> <!-- login -->

                <div
                    class="h-100 d-flex justify-content-center align-items-center text-center bg-white border-1-gray py-5 formDiv">

                    <div class="clearfix my-2 formLogin" id="frontContent">

                        <img src="https://clienti.exactnetwork.net/pretail/assets/brand/exact_logo_blue-trasparente.png"
                            alt="eXact" class="mb-4" style="zoom: 0.8;">

                        <form id="login-form" class="needs-validation" style="margin-top:0%;" novalidate="novalidate">

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <img src="@/assets/loginstart/img/user.png" class="user-icon" />
                                    </span>
                                </div>
                                <input name="username" id="username" class="form-control" type="text"
                                    placeholder="Username" required="">

                            </div>

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <img src="@/assets/loginstart/img/pwd.png" class="password-icon" />
                                    </span>
                                </div>
                                <input name="password" id="password" class="form-control" type="password"
                                    placeholder="Password" required="">

                            </div>

                            <div class="row">


                                <div class="col-6 text-left">
                                    <button id="btn-forgotform" class="btn btn-square px-4" type="button"
                                        style="font-size: smaller;color: #38f; border: 1px solid #38f; padding: 8px;">Password&nbsp;dimenticata?
                                    </button>
                                </div>
                                <div class="col-6 text-right">
                                    <button id="btn-login" class="btn btn-info btn-square px-4" type="button">
                                        Login
                                    </button>
                                </div>


                            </div>



                        </form>


                    </div>



                </div>

            </div>

            <div class="col-12 col-lg-12"> <!-- copyright -->
                <p class="text-muted text-center my-2 small">
                    ©2004-2025 Powered by <a href="https://lc-service.it/" target="_blank">LC-Service srl</a>
                </p>
            </div>

        </div>




    </div>

</template>

<script>




export default {

    updated() { },

    mounted: function () {


    },
    name: "Login",

    // data:
    data() {
        return {

            input: {
                username: "",
                password: "",
            },

        };
    },

    methods: {

    },
};
</script>

<style>
#formLogin {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}


#formLogin .row {
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
    margin-right: -15px !important;
    margin-left: -15px !important;
}

#formLogin .h-100 {
    min-height: 350px !important;
    height: 350px !important
}

#formLogin .w-100 {
    width: 100% !important;
}

#formLogin .align-items-center {
    -ms-flex-align: center !important;
    align-items: center !important;
}

#formLogin .text-white {
    color: #fff !important;
}

#formLogin .bg-dark {
    background-color: #636f83 !important;
}

#formLogin .row.justify-content-center-container {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center !important;
}


#formLogin .row.justify-content-center {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    align-items: center !important;
}


#formLogin a {
    color: var(--info);
    text-decoration: none;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#formLogin .small,
small {
    font-size: 80% !important;
    font-weight: 400 !important;
}

#formLogin .mb-2,
.my-2 {
    margin-bottom: .5rem !important;
}

#formLogin .text-center {
    text-align: center !important;
}

#formLogin .text-muted {
    color: #768192 !important;
    font-size: 12px !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#formLogin .btn-info {
    color: #fff !important;
    background-color: #39f !important;
    border-color: #39f !important;
}

#formLogin .btn-square {
    border-radius: 0;
}

#formLogin .text-right {
    text-align: right !important;
}

#formLogin .btn {
    display: inline-block;
    font-weight: 400;
    color: #3c4b64;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#formLogin .btn-square {
    border-radius: 0;
}

#formLogin .pr-4,
.px-4 {
    padding-right: 1.5rem !important;
}

#formLogin .pl-4,
.px-4 {
    padding-left: 1.5rem !important;
}

#formLogin [type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
}

#formLogin .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

#formLogin .text-left {
    text-align: left !important;
}

#formLogin .password-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
}

#formLogin .user-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
}

#formLogin .mdi-icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
    background: none !important;
    display: inline-block;
}


#formLogin .form-control {
    display: block !important;
    width: 100% !important;
    height: calc(1.5em + .75rem + 2px) !important;
    padding: .375rem .75rem !important;
    font-size: .875rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    background-clip: padding-box !important;
    border: 1px solid !important;
    color: #768192 !important;
    background-color: #fff !important;
    border-color: #d8dbe0 !important;
    border-radius: .25rem !important;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !important;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

#formLogin .input-group>.custom-file,
#formLogin .input-group>.custom-select,
#formLogin .input-group>.form-control,
#formLogin .input-group>.form-control-plaintext {
    position: relative !important;
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
    width: 1% !important;
    min-width: 0 !important;
    margin-bottom: 0 !important;
}

#formLogin html:not([dir=rtl]) .input-group>.custom-select:not(:first-child),
#formLogin html:not([dir=rtl]) .input-group>.form-control:not(:first-child) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}

#formLogin img,
#formLogin svg {
    vertical-align: middle !important;
}

#formLogin svg {
    overflow: hidden !important;
}

#formLogin .c-icon {
    display: inline-block;
    color: inherit;
    text-align: center;
    fill: currentColor;
}

#formLogin .c-icon:not(.c-icon-c-s):not(.c-icon-custom-size) {
    width: 1rem;
    height: 1rem;
    font-size: 1rem;
}

#formLogin .input-group-text {
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    padding: .375rem .75rem !important;
    margin-bottom: 0 !important;
    font-size: .875rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    text-align: center !important;
    white-space: nowrap !important;
    border: 1px solid !important;
    border-radius: .25rem !important;
    color: #768192 !important;
    background-color: #ebedef !important;
    border-color: #d8dbe0 !important;
}

#formLogin html:not([dir=rtl]) .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),
#formLogin html:not([dir=rtl]) .input-group>.input-group-append:last-child>.input-group-text:not(:last-child),
#formLogin html:not([dir=rtl]) .input-group>.input-group-append:not(:last-child)>.btn,
#formLogin html:not([dir=rtl]) .input-group>.input-group-append:not(:last-child)>.input-group-text,
#formLogin html:not([dir=rtl]) .input-group>.input-group-prepend>.btn,
#formLogin html:not([dir=rtl]) .input-group>.input-group-prepend>.input-group-text {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

#formLogin .input-group-prepend {
    white-space: nowrap !important;
    vertical-align: middle !important;
    display: flex !important;
}

#formLogin html:not([dir=rtl]) .input-group-prepend {
    margin-right: -1px !important;
}

#formLogin .mb-3,
#formLogin .my-3 {
    margin-bottom: 1rem !important;
}

#formLogin .input-group {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -ms-flex-align: stretch;
    align-items: stretch;
    width: 100%;
}

#formLogin .mb-2,
#formLogin .my-2 {
    margin-bottom: .5rem !important;
}



#formLogin .mt-2,
#formLogin .my-2 {
    margin-top: .5rem !important;
}

#formLogin .justify-content-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
}

#formLogin .d-flex {
    display: -ms-flexbox !important;
    display: flex !important;
}


#formLogin .bg-white {
    background-color: #fff !important;
}

#formLogin .pb-5,
#formLogin .py-5 {
    padding-bottom: 3rem !important;
}

#formLogin .pt-5,
#formLogin .py-5 {
    padding-top: 3rem !important;
}

#formLogin .h-100 {
    height: 100% !important;
}

#formLogin .align-items-center {
    -ms-flex-align: center !important;
    align-items: center !important;
}

#formLogin .border-1-gray {
    border: 1px solid #aaa;
}

#formLogin .formDiv {
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.5s ease;
}

#backContent {
    position: absolute;
    backface-visibility: hidden;
    transform: rotateY(180deg);
}

#formLogin .rotated {
    transform: rotateY(180deg);
}

#no-style {
    all: revert !important;
}

#fldValueOtpLogin {
    text-align: center !important;
}

.v-text-field input {
    font-size: 12px !important;
}

.clRegistrati {
    font-size: 14px;
    cursor: pointer;
    font-family: 'Roboto', Arial, Helvetica, sans-serif !important;
}



::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c8d4da;
    opacity: 1;
    /* Firefox */
}



.clBtnBack {
    width: 40px;
    margin-top: 45px;
    cursor: pointer;
}
</style>